/**
 * @file 轻量 HTTP 助手（联机建房/入座/开局共用）。
 */

/** POST JSON 并解析应答；非 2xx 或带 error 字段时抛错。 */
export async function postJson<T>(url: string, body: unknown): Promise<T> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = (await res.json()) as T & { readonly error?: string; readonly message?: string };
  if (!res.ok || data.error !== undefined) {
    throw new Error(data.message ?? data.error ?? `HTTP ${res.status}`);
  }
  return data;
}
